import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { TOGGLE_DMX_UNIVERSE_STATUS } from './actionTypes';
import { toggleDmxUniverseStatusSuccessful, toggleDmxUniverseStatusFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* toggleUniverseStatus({ payload: { universe } }) {
  try {
    const response = yield call(
      dmxAPI.toggleUniverseStatus,
      universe.token,
      universe.id,
      universe.active,
    );
    if (response.message) {
      yield put(toggleDmxUniverseStatusSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(toggleDmxUniverseStatusFailed(error));
  }
}

export function* watchToggleDmxUniverseStatus() {
  yield takeEvery(TOGGLE_DMX_UNIVERSE_STATUS, toggleUniverseStatus);
}

function* toggleDmxUniverseStatusSaga() {
  yield all([fork(watchToggleDmxUniverseStatus)]);
}

export default toggleDmxUniverseStatusSaga;
